import { render, staticRenderFns } from "./Safelock.vue?vue&type=template&id=7c63b58d&scoped=true&"
import script from "./Safelock.vue?vue&type=script&lang=js&"
export * from "./Safelock.vue?vue&type=script&lang=js&"
import style0 from "./Safelock.vue?vue&type=style&index=0&id=7c63b58d&lang=scss&scoped=true&"
import style1 from "./Safelock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63b58d",
  null
  
)

export default component.exports